import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    padding: theme.spacings.md,
    rowGap: theme.spacings.xl,
  },
  infoText: {
    fontSize: theme.fontSizes.xl,
  },
  buttonRow: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  consentText: {
    fontSize: theme.fontSizes.lg,
    padding: theme.spacings.md,
  },
});
